import {
  FooterContainer,
  StepTitle,
  FooterButton,
  WizardContentWrapper,
  FooterBackButton,
  StepContent,
  FooterButtonGroup,
} from "@/components/onboarding/components/WelcomeWizard/WelcomeWizard.styles";
import type { StepProps } from "@/components/onboarding/components/WelcomeWizard/WelcomeWizard.types";
import styled from "@emotion/styled";
import { MDSText, MDSTextVariant, MDSTextWeight } from "@/mds";
import ImportHowToGif from "@/assets/images/onboarding/import-how-to.gif";

export const SkipConfirmationStep = ({ onClose: _onClose, onNavToStep }: StepProps) => {
  return (
    <WizardContentWrapper>
      <StepTitle>Import and download apps later</StepTitle>
      <StepContent>
        <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
          You can always bring in notes from other apps later in your user profile menu, in the top
          left corner of your screen.
        </MDSText>
        <GifWrapper>
          <img
            src={ImportHowToGif}
            alt="Click the dropdown arrow next to the Create note button and then select Import"
          />
        </GifWrapper>
      </StepContent>
      <FooterContainer>
        <FooterButtonGroup>
          <FooterBackButton onClick={() => onNavToStep?.("app-selection")}>Back</FooterBackButton>
          <FooterButton onClick={() => onNavToStep?.("download-apps")}>Next</FooterButton>
        </FooterButtonGroup>
      </FooterContainer>
    </WizardContentWrapper>
  );
};

const GifWrapper = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.large};
  overflow: hidden;

  img {
    width: 588px;
    height: 270px;
  }
`;
